import { Fragment, useRef, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { EnvelopeIcon } from '@heroicons/react/20/solid';

const initialFormData = Object.freeze({
	firstName: '',
	lastName: '',
	clientId: '',
	username: 'admin.user',
	password: '',
	consultantFirstName: '',
	consultantLastName: '',
	consultantPassword: '',
	consultantUsername: '',
	consultantEmail: '',
});

const NewClientModal = ({ open, setOpen }) => {
	const cancelButtonRef = useRef(null);
	const form = useRef(null);
	const [client, setClient] = useState(initialFormData);

	const handleSubmit = e => {
		e.preventDefault();

		console.log(client);
		const cloneUrl = '/client/v1/clients/clone';

		axios({
			method: 'POST',
			url: cloneUrl,
			data: client,
		}).then(
			response => {
				console.log(response);
				toast('Client ' + client.clientId + ' created', {
					autoClose: 6000,
					type: toast.TYPE.SUCCESS,
				});
				setOpen(false);
			},
			error => {
				console.log(error);
				toast('Client ' + client.clientId + ' NOT created', {
					autoClose: 6000,
					type: toast.TYPE.ERROR,
				});
			},
		);
	};

	const handleChange = e => {
		setClient({
			...client,

			// Trimming any whitespace
			[e.target.name]: e.target.value.trim(),
		});
	};

	return (
		<Transition.Root show={open} as={Fragment}>
			<Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpen}>
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0">
					<div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
				</Transition.Child>

				<div className="fixed inset-0 z-10 overflow-y-auto">
					<div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
							enterTo="opacity-100 translate-y-0 sm:scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 translate-y-0 sm:scale-100"
							leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
							<Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
								<form ref={form}>
									<div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-2">
										<div className="sm:col-span-1">
											<label
												htmlFor="input_emailAddress"
												className="ml-3 block text-sm font-medium text-gray-700">
												Client Name
											</label>
											<input
												required
												name="clientId"
												type="text"
												className="block w-full min-w-0 flex-1 rounded-none rounded-l-md rounded-r-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm invalid:border-red-500"
												id="client_name"
												placeholder="Client name"
												onChange={handleChange}
												tabIndex="1"
											/>
										</div>
										<div className="sm:col-span-1">
											<div>
												<label
													htmlFor="input_firstName"
													className="ml-3 block text-sm font-medium text-gray-700">
													Consultant First Name
												</label>
												<input
													className="block w-full min-w-0 flex-1 rounded-none rounded-l-md rounded-r-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm invalid:border-red-500"
													id="input_consultant_firstName"
													placeholder="Consultant first name"
													type="text"
													name="consultantFirstName"
													onChange={handleChange}
													tabIndex="6"
												/>
											</div>
										</div>
										<div className="sm:col-span-1">
											<label
												htmlFor="input_firstName"
												className="ml-3 block text-sm font-medium text-gray-700">
												{' '}
												Admin First Name
											</label>
											<input
												required
												className="block w-full min-w-0 flex-1 rounded-none rounded-l-md rounded-r-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm invalid:border-red-500"
												id="input_firstName"
												placeholder="First name"
												type="text"
												name="firstName"
												onChange={handleChange}
												tabIndex="2"
											/>
										</div>
										<div className="sm:col-span-1">
											<label
												htmlFor="input_lastName"
												className="ml-3 block text-sm font-medium text-gray-700">
												Consultant Last Name
											</label>
											<input
												className="block w-full min-w-0 flex-1 rounded-none rounded-l-md rounded-r-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm invalid:border-red-500"
												id="input_consultant_lastName"
												placeholder="Consultant last name"
												type="text"
												name="consultantLastName"
												onChange={handleChange}
												tabIndex="7"
											/>
										</div>
										<div className="sm:col-span-1">
											<label
												htmlFor="input_lastName"
												className="ml-3 block text-sm font-medium text-gray-700">
												Admin Last Name
											</label>
											<input
												required
												className="block w-full min-w-0 flex-1 rounded-none rounded-l-md rounded-r-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm invalid:border-red-500"
												id="input_lastName"
												placeholder="Last name"
												type="text"
												name="lastName"
												onChange={handleChange}
												tabIndex="3"
											/>
										</div>
										<div className="sm:col-span-1">
											<label
												htmlFor="input_consultant_username"
												className="ml-3 block text-sm font-medium text-gray-700">
												Consultant UserName
											</label>
											<input
												className="block w-full min-w-0 flex-1 rounded-none rounded-l-md rounded-r-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm invalid:border-red-500"
												id="input_consultant_username"
												placeholder="Consultant user name"
												type="text"
												name="consultantUsername"
												onChange={handleChange}
												tabIndex="8"
											/>
										</div>
										<div className="sm:col-span-1">
											<label
												htmlFor="input_alias"
												className="ml-3 block text-sm font-medium text-gray-700">
												UserName
											</label>
											<input
												readOnly
												type="text"
												className="block w-full min-w-0 flex-1 rounded-none rounded-l-md rounded-r-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm invalid:border-red-500"
												id="username"
												onChange={handleChange}
												tabIndex="4"
												defaultValue="admin.user"
											/>
										</div>
										<div className="sm:col-span-1">
											<label
												htmlFor="input_consultant_emailAddress"
												className="ml-3 block text-sm font-medium text-gray-700">
												Consultant Password
											</label>
											<input
												type="password"
												className="block w-full min-w-0 flex-1 rounded-none rounded-l-md rounded-r-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm invalid:border-red-500"
												id="input_consultant_password"
												placeholder="Consultant password"
												onChange={handleChange}
												name="consultantPassword"
												tabIndex="9"
											/>
										</div>
										<div className="sm:col-span-1">
											<div>
												<label
													htmlFor="input_uniqueID"
													className="ml-3 block text-sm font-medium text-gray-700">
													Admin Password
												</label>
												<input
													required
													type="password"
													className="block w-full min-w-0 flex-1 rounded-none rounded-l-md rounded-r-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm invalid:border-red-500"
													id="input_password"
													placeholder="Password"
													name="password"
													onChange={handleChange}
													tabIndex="5"
												/>
											</div>
										</div>
										<div className="sm:col-span-1">
											<label
												htmlFor="input_consultant_emailAddress"
												className="ml-3 block text-sm font-medium text-gray-700">
												Consultant Email Address
											</label>
											<div className="relative mt-1 rounded-md shadow-sm">
												<div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
													<EnvelopeIcon
														className="h-5 w-5 text-gray-400"
														aria-hidden="true"
													/>
												</div>
												<input
													className="block w-full rounded-md border-gray-300 pl-10 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
													id="input_consultant_emailAddress"
													name="consultantEmail"
													type="email"
													placeholder="facilitator@yourcompany.com"
													onChange={handleChange}
													tabIndex="10"
												/>
											</div>

											{/*<div className="relative mt-1 rounded-md shadow-sm">*/}
											{/*	<div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">*/}
											{/*		<EnvelopeIcon*/}
											{/*			className="h-5 w-5 text-gray-400"*/}
											{/*			aria-hidden="true"*/}
											{/*		/>*/}
											{/*	</div>*/}
											{/*	<input*/}
											{/*		type="email"*/}
											{/*		name="email"*/}
											{/*		id="email"*/}
											{/*		className="block w-full rounded-md border-gray-300 pl-10 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"*/}
											{/*		placeholder="you@example.com"*/}
											{/*	/>*/}
											{/*</div>*/}
										</div>
									</div>
								</form>
								<div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
									<button
										className="inline-flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-2 sm:text-sm"
										onClick={e => {
											handleSubmit(e);
										}}
										tabIndex="11">
										Add Client
									</button>
									<button
										type="button"
										className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-1 sm:mt-0 sm:text-sm"
										onClick={() => {
											setOpen(false);
										}}
										ref={cancelButtonRef}>
										Cancel
									</button>
								</div>
							</Dialog.Panel>
						</Transition.Child>
					</div>
				</div>
			</Dialog>
		</Transition.Root>
	);
};

export default NewClientModal;
